import React, { Component } from 'react'
import { array } from 'prop-types'
import styled from 'styled-components'
import Slider from 'react-slick'
import { rgba } from 'polished'

import CarouselSlide from './CarouselSlide'
import { NavigateButton } from 'components/home/FeaturedProduct'
import Icon from 'components/Icon'
import { media } from 'styles/media'
import * as spacing from 'styles/spacing'
import { black, white } from 'styles/colors'
import { fontSizes, fontWeights } from 'styles/typography'

import LeftChevron from 'icons/left-chevron.svg'
import RightChevron from 'icons/right-chevron.svg'

const Container = styled.div`
  position: relative;
  background-color: #14191d;
  height: 100%;

  .slick-slider,
  .slick-list,
  .slick-track {
    height: 100%;
  }

  .slick-slide > div {
    width: 100%;
    height: 100%;
  }
`

const Footer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 140px;
  background-color: ${rgba(black, 0.1)};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
  backface-visibility: hidden;
`

const ArrowWrap = styled.div`
  position: absolute;
  width: 310px;
  top: 133px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  margin: auto;
  pointer-events: none;

  ${media.small`
    top: 168px;
    width: 340px;
  `};
`

const Arrow = styled.button`
  display: flex;
  color: ${white};
  padding: ${spacing.small};
  margin: -${spacing.small};
  pointer-events: auto;
`

const Pagination = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  color: ${white};
  font-size: ${fontSizes.tiny};
  font-weight: ${fontWeights.medium};
  text-transform: uppercase;
  padding-top: 20px;

  ${media.small`
    padding-top: 28px;
  `};

  li {
    display: none;

    &.slick-active {
      display: block;
    }
  }
`

export default class FlavourCarousel extends Component {
  static propTypes = {
    flavours: array.isRequired,
    navigation: array.isRequired
  }

  constructor(props) {
    super(props)
    this.next = this.next.bind(this)
    this.previous = this.previous.bind(this)
  }
  next() {
    this.slider.slickNext()
  }
  previous() {
    this.slider.slickPrev()
  }

  render() {
    const settings = {
      dots: true,
      infinite: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      appendDots: dots => (
        <Pagination>
          {dots}&nbsp;of {this.props.flavours.length} flavours
        </Pagination>
      ),
      customPaging: function (i) {
        return <span>{i + 1}</span>
      }
    }
    return (
      <Container className="u-hide-medium-up">
        <Slider ref={c => (this.slider = c)} {...settings}>
          {this.props.flavours.map((flavour, i) => (
            <CarouselSlide
              key={i}
              name={flavour.prettyName}
              price={flavour.price}
              slug={flavour.slug}
              link={flavour.link}
              description={flavour.description}
              background={flavour.background}
            />
          ))}
        </Slider>
        <Footer>
          {this.props.navigation.length > 0 &&
            this.props.navigation.map((item, i) => (
              <NavigateButton key={i} label={item.label} onClick={item.onClick} icon={item.icon} />
            ))}
        </Footer>
        <ArrowWrap>
          <Arrow onClick={this.previous}>
            <Icon icon={<LeftChevron />} size="medium" />
          </Arrow>
          <Arrow onClick={this.next}>
            <Icon icon={<RightChevron />} size="medium" />
          </Arrow>
        </ArrowWrap>
      </Container>
    )
  }
}
